import type { ReactNode } from 'react';
import { Section } from './Section';
import type { Tone } from '../../ui/sections';
type Props = {
  tone: Extract<Tone, 'blush' | 'clay'>;
  /** Id van de kop, voor `aria-labelledby`. */
  titleId: string;
  /** De kop zelf (meestal `<HeadingText heading={…} />`). */
  title: ReactNode;
  body?: ReactNode;
  /** Eén of twee knoppen (`btnPrimaryLg`/`btnSecondaryLg` op blush, `btnOnClay` op klei). */
  actions?: ReactNode;
};

/**
 * Het slot van een inhoudspagina: kop en zin links, de knoppen rechts op dezelfde onderlijn.
 * Op blush (twijfel) of op klei (het ene klei-moment van de pagina).
 */
export function ClosingBand({
  tone,
  titleId,
  title,
  body,
  actions
}: Props) {
  const onClay = tone === 'clay';
  return <Section tone={tone} labelledBy={titleId} pad="compact" className="grid gap-8 lg:grid-cols-12 lg:items-end lg:gap-16" data-id="element-8849" data-mp="2zid1680dlv18">
      <div className="lg:col-span-7" data-id="element-8850" data-mp="1a4ztq9wyvqvw">
        <h2 id={titleId} className="type-sub" data-id="element-8851" data-mp="154c2bn4tt815">
          {title}
        </h2>
        {body && <p className={`mt-4 max-w-2xl text-[17px] leading-relaxed ${onClay ? 'text-shell' : 'text-muted'}`} data-id="element-8852" data-mp="14u02rpudxeuw">{body}</p>}
      </div>
      {actions && <div className="flex flex-col gap-3 sm:flex-row lg:col-span-5 lg:justify-end" data-id="element-8853" data-mp="18w4w0ngx89h0">{actions}</div>}
    </Section>;
}